import api from './api'

export const rncpService = {
  // Récupération des certifications RNCP
  getCertifications: async (params = {}) => {
    const response = await api.get('/rncp/certifications', { params })
    return response.data
  },

  // Récupération des données pour la visualisation
  getVisualizationData: async (params = {}) => {
    const response = await api.get('/rncp/visualization-data', { params })
    return response.data
  },

  // Analyse de fusion des compétences
  getCompetenceFusion: async (params = {}) => {
    const response = await api.get('/rncp/competence-fusion', { params })
    return response.data
  },

  // Import de données CSV RNCP
  importCsvData: async (file) => {
    const formData = new FormData()
    formData.append('file', file)

    const response = await api.post('/import-export/import-rncp', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  },

  // Export des données de visualisation
  exportVisualizationData: async (format = 'csv', params = {}) => {
    const response = await api.get(`/import-export/export-rncp/${format}`, {
      params,
      responseType: 'blob'
    })
    return response.data
  }
}